"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LOG_DELIVERY_STREAM_NAME = 'gb-web-metrics-v3';
exports.DEFAULT_METRICS_DELIVERY_STREAM_NAME = 'gb-webclient-metrics';
var LOG_DELIVERY_STREAM_NAME_NRT = 'gb-web-metrics-v2';
exports.DELIVERY_STREAM_NAME = {
    DEV: {
        'us-east-1': {
            logStream: exports.DEFAULT_LOG_DELIVERY_STREAM_NAME,
            metricsStream: exports.DEFAULT_METRICS_DELIVERY_STREAM_NAME
        }
    },
    ALPHA: {
        'us-east-1': {
            logStream: exports.DEFAULT_LOG_DELIVERY_STREAM_NAME,
            metricsStream: exports.DEFAULT_METRICS_DELIVERY_STREAM_NAME
        }
    },
    BETA: {
        'us-east-1': {
            logStream: exports.DEFAULT_LOG_DELIVERY_STREAM_NAME,
            metricsStream: exports.DEFAULT_METRICS_DELIVERY_STREAM_NAME
        }
    },
    GAMMA: {
        'us-east-1': {
            logStream: exports.DEFAULT_LOG_DELIVERY_STREAM_NAME,
            metricsStream: exports.DEFAULT_METRICS_DELIVERY_STREAM_NAME
        }
    },
    PROD: {
        'ap-southeast-2': {
            logStream: exports.DEFAULT_LOG_DELIVERY_STREAM_NAME,
            metricsStream: exports.DEFAULT_METRICS_DELIVERY_STREAM_NAME
        },
        'ap-northeast-1': {
            logStream: LOG_DELIVERY_STREAM_NAME_NRT,
            metricsStream: exports.DEFAULT_METRICS_DELIVERY_STREAM_NAME
        },
        'eu-west-1': {
            logStream: exports.DEFAULT_LOG_DELIVERY_STREAM_NAME,
            metricsStream: exports.DEFAULT_METRICS_DELIVERY_STREAM_NAME
        },
        'us-west-2': {
            logStream: exports.DEFAULT_LOG_DELIVERY_STREAM_NAME,
            metricsStream: exports.DEFAULT_METRICS_DELIVERY_STREAM_NAME
        },
        'us-east-1': {
            logStream: exports.DEFAULT_LOG_DELIVERY_STREAM_NAME,
            metricsStream: exports.DEFAULT_METRICS_DELIVERY_STREAM_NAME
        },
        'ap-southeast-1': {
            logStream: exports.DEFAULT_LOG_DELIVERY_STREAM_NAME,
            metricsStream: exports.DEFAULT_METRICS_DELIVERY_STREAM_NAME
        },
        'us-west-2-prod-beta': {
            logStream: exports.DEFAULT_LOG_DELIVERY_STREAM_NAME,
            metricsStream: exports.DEFAULT_METRICS_DELIVERY_STREAM_NAME
        }
    },
    DEFAULT: {
        logStream: exports.DEFAULT_LOG_DELIVERY_STREAM_NAME,
        metricsStream: exports.DEFAULT_METRICS_DELIVERY_STREAM_NAME
    }
};
